export default __webpack_public_path__ + "static/media/contributers.ca6a2809.svg";